import * as types from "../../constants";
import axios from "../../../axios";

const getOrganizationsRequest = () => ({
    type: types.GET_ORGANIZATIONS_REQUEST
});

const getOrganizationsSuccess = data => ({
    type: types.GET_ORGANIZATIONS_SUCCESS,
    data
});

const getOrganizationsFail = error => ({
    type: types.GET_ORGANIZATIONS_FAILURE,
    error
});


export const getOrganizations = () => {
    return async (dispatch) => {
        try {
            dispatch(getOrganizationsRequest());  
            let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization`);            
            
            dispatch(getOrganizationsSuccess(data))
        }
        catch (err) {
            dispatch(getOrganizationsFail());
            console.log("Error while getting groups of an organization", err.message);
        }

    }
}
